"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTEXT_ID_KEY = exports.INSTANCE_ID_KEY = exports.PACKAGE_NAME = void 0;
exports.instanceId = instanceId;
exports.contextId = contextId;
exports.applyUserInteractionHook = applyUserInteractionHook;
exports.removeSearchParameterFromUrl = removeSearchParameterFromUrl;
const adapter_1 = require("../api/adapter");
const utils_1 = require("../internal/utils");
exports.PACKAGE_NAME = "VDC-core";
exports.INSTANCE_ID_KEY = "vdc:instanceId";
exports.CONTEXT_ID_KEY = "vdc:contextId";
/**
 * Machine ID is global across all VDC instances in the current browser/platform
 */
function instanceId() {
    if (adapter_1.device.isImplements(adapter_1.Feature.LOCAL_STORAGE)) {
        if (adapter_1.device.localStorage.getItem(exports.INSTANCE_ID_KEY) == null) {
            adapter_1.device.localStorage.setItem(exports.INSTANCE_ID_KEY, (0, utils_1.uuidv4)());
        }
        return adapter_1.device.localStorage.getItem(exports.INSTANCE_ID_KEY);
    }
    return null;
}
/**
 * Context ID is global for current session
 */
function contextId() {
    if (!adapter_1.device.globals.has(exports.CONTEXT_ID_KEY)) {
        adapter_1.device.globals.set(exports.CONTEXT_ID_KEY, (0, utils_1.uuidv4)());
    }
    const id = adapter_1.device.globals.get(exports.CONTEXT_ID_KEY);
    return typeof id === "string" ? id : null;
}
function applyUserInteractionHook() {
    adapter_1.device.applyUserInteractionHook();
}
function removeSearchParameterFromUrl(url, paramName) {
    const pattern = new RegExp(`([?&])${paramName}=[^&]*`, "g");
    return url.replace(pattern, "");
}
//# sourceMappingURL=common.js.map